module.exports = __webpack_public_path__ + "img/footer_icon_insta.6cc99223.svg";